import React, { useEffect } from "react";
import withIntl from "../utils/withIntl";
import articlesStore from "../store/articles/ArticlesStore";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import Article from "../components/ArticlesMenu/Article";
import Typography from "@material-ui/core/Typography";
import { Chip, CircularProgress, Grid, IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import { getArticles } from "../store/articles/ArticlesApi";
import { useParams } from "react-router-dom";
import { Add, Remove } from "@material-ui/icons";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { _post } from "../Api";
import { toast } from "react-toastify";
import Divider from "@material-ui/core/Divider";
import GetCurrency from "../helper/GetCurrency";
import TranslationFormButton from "../components/TranslationForm/TranslationFormButton";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  MuiGridGridXs12: {
    margin: 3,
    backgroundColor: "pink",
  },
}));

const emptyBestsellers = { name: {}, articles: [] };

function Bestsellers(props) {
  const merchantId = Number.parseInt(useParams().merchantId);
  const [articles, setArticles] = React.useState(articlesStore.articles);

  const getBestsellers = (bestsellers) => {
    if (articles == null) {
      return bestsellers;
    }
    bestsellers.articles = bestsellers.articles.filter((article) => articles[article.id]);
    return bestsellers;
  };

  const [bestsellers, setBestsellers] = React.useState(
    getBestsellers(
      cloudStore.merchant.best_sellers == null
        ? JSON.parse(JSON.stringify(emptyBestsellers))
        : cloudStore.merchant.best_sellers
    )
  );

  const classes = useStyles();

  const [searchValueBestsellers, setSearchValueBestsellers] = React.useState();
  const [searchValueArticles, setSearchValueArticles] = React.useState();

  // const [articleItems, setArticleItems] = React.useState(articles);

  function onChangeArticles() {
    setArticles(articlesStore.articles);
    setBestsellers(getBestsellers(bestsellers));
  }

  const postBestsellers = (translateId, newBestsellersObject) => {
    const oldBestsellers = bestsellers;
    const body = [{ merchantId: merchantId, best_sellers: newBestsellersObject }];
    return _post("/nova/v2/merchants", body)
      .then(() => {
        toast.success(props.intl.formatMessage({ id: translateId }), {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setBestsellers(newBestsellersObject);
        Promise.resolve();
      })
      .catch(() => {
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setBestsellers(oldBestsellers);
        Promise.reject();
      });
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    if (cloudStore.merchant != null) {
      onChangeArticles();
    }
    return () => cloudStore.removeListener(cloudStoreEvents.ARTICLES_UPDATED, onChangeArticles);
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (articles != null) {
        setArticles(null);
      }
      getArticles(merchantId);
    } else if (articles == null && articlesStore.articles != null) {
      onChangeArticles();
    }
  }, []);

  if (articles == null) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const articlesArrayFiltered = searchValueArticles
    ? Object.keys(articles)
        .map((articleKey) => articles[articleKey])
        .filter((articleObject) => {
          return (
            articleObject.name.toLowerCase().includes(searchValueArticles?.toLowerCase()) ||
            articleObject.plu.toLowerCase().includes(searchValueArticles?.toLowerCase())
          );
        })
    : Object.keys(articles).map((articleKey) => articles[articleKey]);

  const bestsellersArrayFiltered = searchValueBestsellers
    ? bestsellers.articles
        .map((bestseller) => articles[bestseller.id])
        .filter((articleObject) => {
          return (
            articleObject.name.toLowerCase().includes(searchValueBestsellers?.toLowerCase()) ||
            articleObject.plu.toLowerCase().includes(searchValueBestsellers?.toLowerCase())
          );
        })
    : bestsellers?.articles.map((bestseller) => articles[bestseller.id]);

  const addArticleToBestsellersList = (article) => {
    if (bestsellers?.articles.some((bestseller) => bestseller.id === article.id)) {
    } else {
      const articleObject = { id: article.id };
      const newBestsellersArray = bestsellers?.articles ? [...bestsellers.articles] : [];
      newBestsellersArray.push(articleObject);
      const newBestsellersObject = { ...bestsellers, articles: newBestsellersArray };
      // setBestsellers(newBestsellersObject);
      postBestsellers("article_added_to_bestsellers", newBestsellersObject);
    }
  };

  const removeArticleFromBestsellersList = (article) => {
    let newBestsellersArray = [...bestsellers.articles];
    const index = newBestsellersArray.map((object) => object.id).findIndex((id) => id === article.id);
    newBestsellersArray.splice(index, 1);
    const newBestsellersObject = { ...bestsellers, articles: newBestsellersArray };
    // setBestsellers(newBestsellersObject);
    postBestsellers("article_removed_from_bestsellers", newBestsellersObject);
  };

  const updateTranslations = (language, value) => {
    const newTranslationsObject = { ...bestsellers.name, [language]: value };
    const newBestsellersObject = { ...bestsellers, name: newTranslationsObject };
    setBestsellers(newBestsellersObject);
    return postBestsellers("translations_updated", newBestsellersObject);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(bestsellers.articles);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const newBestsellersObject = { ...bestsellers, articles: items };
    setBestsellers(newBestsellersObject);
    postBestsellers("translations_updated", newBestsellersObject);
  };

  return (
    <div>
      <Typography gutterBottom variant="h5" style={{ textAlign: "left" }}>
        {props.intl.formatMessage({ id: "bestsellers" })} - {cloudStore.merchant?.name}
      </Typography>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Paper className={classes.paper}>
              <Grid xs={12}>
                <div style={{ textAlign: "left", display: "flex", alignItems: "center" }}>
                  <Typography variant="h5" display={"inline"}>
                    {props.intl.formatMessage({ id: "bestsellers" })}
                  </Typography>
                  <div style={{ width: 20 }}>
                    <TranslationFormButton
                      translationField={"bestsellers"}
                      updateTranslations={updateTranslations}
                      translationsObject={bestsellers?.name ? bestsellers.name : emptyBestsellers.name}
                      translationFields={cloudStore.merchant.languages
                        ?.filter((language) => language.active)
                        .map((object) => object.language)}
                    />
                  </div>
                </div>
                <Divider style={{ marginBottom: 10 }} />
              </Grid>
              <Grid xs={12}>
                <TextField
                  style={{ width: "100%" }}
                  value={searchValueBestsellers}
                  onChange={(event) => setSearchValueBestsellers(event.target.value)}
                  size={"small"}
                  label="Search"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment:
                      searchValueBestsellers?.length > 0 ? (
                        <InputAdornment position="end">
                          <ClearIcon onClick={() => setSearchValueBestsellers("")} />
                        </InputAdornment>
                      ) : null,
                  }}
                />
              </Grid>
              <Grid xs={12}>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="droppable-bestSellers">
                    {(provided) => (
                      <div className={classes.bestsellersList} {...provided.droppableProps} ref={provided.innerRef}>
                        {bestsellersArrayFiltered?.map((article, index) => {
                          return (
                            <Draggable
                              key={article.id}
                              draggableId={`droppable-bestSellers - ${article.id}`}
                              index={index}
                            >
                              {(provided) => (
                                <ul {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                  <Grid container spacing={1}>
                                    <Grid
                                      item
                                      xs={6}
                                      style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
                                    >
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography>{article.name}</Typography>
                                        {article.weight != null ? (
                                          <Chip size={"small"} label={"AYCE " + article.weight} />
                                        ) : null}
                                        {article.getPrintTags().map((printTag) => {
                                          return <Chip size={"small"} label={printTag} />;
                                        })}
                                      </div>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={3}
                                      style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
                                    >
                                      <Typography style={{ textAlign: "right" }}>
                                        {GetCurrency() + " " + (article.price / 100).toFixed(2)}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                      <IconButton
                                        onClick={() => {
                                          removeArticleFromBestsellersList(article);
                                        }}
                                      >
                                        <Remove />
                                      </IconButton>
                                    </Grid>
                                  </Grid>
                                </ul>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paper}>
              <Grid xs={12}>
                <Typography variant="h5" style={{ textAlign: "left" }}>
                  Menu
                </Typography>
                <Divider style={{ marginBottom: 10 }} />
              </Grid>
              <Grid xs={12}>
                <TextField
                  style={{ width: "100%" }}
                  value={searchValueArticles}
                  onChange={(event) => setSearchValueArticles(event.target.value)}
                  size={"small"}
                  label="Search"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment:
                      searchValueArticles?.length > 0 ? (
                        <InputAdornment position="end">
                          <ClearIcon onClick={() => setSearchValueArticles("")} />
                        </InputAdornment>
                      ) : null,
                  }}
                />
              </Grid>
              <Grid xs={12}>
                {articlesArrayFiltered.map((article) => (
                  <Article
                    key={article.id}
                    index={article.id}
                    article={article}
                    onAction={() => addArticleToBestsellersList(article)}
                    showActionButton={true}
                    actionIcon={<Add />}
                  />
                ))}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default withIntl(Bestsellers);
